module.exports = __webpack_public_path__ + "static/img/baojing_img.b1388d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/baojing_img.png
// module id = ftWC
// module chunks = 1